import React from "react";

import styled from "styled-components/macro";

export function FnrOverlayButtonRow({ children, ...props }) {
  return <Wrapper {...props}>{children}</Wrapper>;
}

const Wrapper = styled.div`
  display: flex;
  margin-top: 24px;
  align-items: center;
  justify-content: space-between;
`;
